// The company's own name for screens and tab titles, from the company settings the server sends
// in `me.company`. Nothing about one company is written into the screens themselves.
export function companyBrandName(company, fallback = "Intranet") {
  return company?.brandName || company?.displayName || fallback;
}
